import { createSlice } from "@reduxjs/toolkit";

const jewellerDocumentSlice = createSlice({
  name: "jewellerDocument",
  initialState: {
    configuration: [],
    configurationLoading: false,
    configurationLoaded: false,
    uploadingIndex: null,
    uploadResult: null,
    uploadError: null,
    saving: false,
    documents: [],
    documentsLoading: false,
    documentsJewellerId: "",
  },
  reducers: {
    getDocumentConfigurationRequest: (state) => {
      state.configurationLoading = true;
    },
    getDocumentConfigurationSuccess: (state, action) => {
      state.configurationLoading = false;
      state.configurationLoaded = true;
      state.configuration = Array.isArray(action.payload) ? action.payload : [];
    },
    getDocumentConfigurationFailure: (state) => {
      state.configurationLoading = false;
      state.configurationLoaded = true;
      state.configuration = [];
    },
    uploadJewellerDocumentRequest: (state, action) => {
      state.uploadingIndex = action.payload?.cardIndex ?? null;
      state.uploadError = null;
    },
    uploadJewellerDocumentSuccess: (state, action) => {
      state.uploadingIndex = null;
      state.uploadResult = action.payload;
      state.uploadError = null;
      if (action.payload?.data?.file?.length) {
        state.documents = [action.payload.data];
      }
    },
    uploadJewellerDocumentFailure: (state, action) => {
      state.uploadingIndex = null;
      state.uploadError = action.payload;
    },
    clearUploadJewellerDocument: (state) => {
      state.uploadingIndex = null;
      state.uploadResult = null;
      state.uploadError = null;
    },
    saveDocumentConfigurationRequest: (state) => {
      state.saving = true;
    },
    saveDocumentConfigurationSuccess: (state, action) => {
      state.saving = false;
      if (Array.isArray(action.payload) && action.payload.length) {
        state.configurationLoaded = true;
        state.configuration = action.payload;
      }
    },
    saveDocumentConfigurationFailure: (state) => {
      state.saving = false;
    },
    getDocumentsRequest: (state, action) => {
      state.documentsLoading = true;
      state.documentsJewellerId = action.payload?.jewellerId || "";
      state.documents = [];
    },
    getDocumentsSuccess: (state, action) => {
      if (state.documentsJewellerId !== action.payload?.jewellerId) return;
      state.documentsLoading = false;
      state.documents = Array.isArray(action.payload?.records)
        ? action.payload.records
        : [];
    },
    getDocumentsFailure: (state, action) => {
      if (
        action.payload?.jewellerId &&
        state.documentsJewellerId !== action.payload.jewellerId
      ) {
        return;
      }
      state.documentsLoading = false;
      state.documents = [];
    },
    updateJewellerDocumentRequest: (state, action) => {
      state.uploadingIndex = action.payload?.cardIndex ?? null;
      state.uploadError = null;
    },
  },
});

export const {
  getDocumentConfigurationRequest,
  getDocumentConfigurationSuccess,
  getDocumentConfigurationFailure,
  uploadJewellerDocumentRequest,
  uploadJewellerDocumentSuccess,
  uploadJewellerDocumentFailure,
  clearUploadJewellerDocument,
  saveDocumentConfigurationRequest,
  saveDocumentConfigurationSuccess,
  saveDocumentConfigurationFailure,
  getDocumentsRequest,
  getDocumentsSuccess,
  getDocumentsFailure,
  updateJewellerDocumentRequest,
} = jewellerDocumentSlice.actions;

export default jewellerDocumentSlice.reducer;
